// Which screen App renders once bootstrap data is in. Pure, so the order is
// unit-tested (gates.test.ts) without a DOM.
//
// Order:
//   0. /data-requests (review W29) → the Data requests page, ahead of every
//      gate: answering a customer's data request is a legal duty that no
//      paywall or unfinished onboarding may hide, and the notice email's
//      deep link must land.
//   1. Free period ended, no plan (review W31) → the end-of-period picker,
//      on every session, BEFORE onboarding: a capped store's destination
//      saves 402, so onboarding can't finish. It can be skipped only with
//      at least one destination (there's a dashboard with the paused rows
//      to see), and only with its own session flag: a "Maybe later" taken
//      during the free period can't hide it.
//   2. 0 destinations → onboarding.
//   3. No plan, not skipped this session, not comped → the picker.
//   4. Otherwise → the main app.

import { freePeriodEnded, type FreePeriodBilling } from "./billing-shared";

export type Gate = "data-requests" | "picker-ended" | "onboarding" | "picker" | "main";

export const DATA_REQUESTS_PATH = "/data-requests";

export interface GateInput {
  destinationsCount: number;
  billing: FreePeriodBilling;
  /** "Maybe later" on the in-window picker (dc_pickerSkipped). */
  pickerSkipped: boolean;
  /** "Not now" on the end-of-period picker (dc_pickerSkippedEnded). */
  pickerSkippedEnded: boolean;
  /** The URL path; omitted, the gate is the one the rest of the app sits behind. */
  path?: string;
  now?: number;
}

export function resolveGate(input: GateInput): Gate {
  if (input.path === DATA_REQUESTS_PATH) return "data-requests";
  if (freePeriodEnded(input.billing, input.now)) {
    return input.destinationsCount > 0 && input.pickerSkippedEnded ? "main" : "picker-ended";
  }
  if (input.destinationsCount === 0) return "onboarding";
  if (input.billing.subscription === null && !input.pickerSkipped && !input.billing.comped) return "picker";
  return "main";
}
